<template>
	<div id="app">
		<div class="screen" :class="{'show': !navbar.collapse}" @click='onScreenClick' @touch='onScreenClick' @touchmove.prevent></div>
		<div v-show="auth" class="nav-container" :class="{customer: !isStaff}">
			<!-- Fixed navbar -->
			<nav class="navbar navbar-default navbar-fixed-top">
				<div class="container">
					<div class="navbar-header">
						<div class="col-md-2 col-sm-2 col-xs-2">
							<img :src="logoPath" style="height:28px;margin:10px 10px 10px 10px;">
						</div>
						<div class="col-md-8 col-sm-8 col-xs-8">
							<div class="navbar-brand" style="display:inline-block;width:100%;text-align:center;">{{ page.title }}
							</div>
						</div>
						<div class="col-md-2 col-sm-2 col-xs-2">
							<div style="float:right; display:block;">
								<img :src="menuBtn" @click='onNavbarToggle' style="width:24px;height:22px;margin:14px 15px;">
							</div>
						</div>
					</div>
					<div class="navbar-collapse collapse" :class="{'in': !navbar.collapse}">
						<div class="clear-fix"></div>
						<ul class="nav navbar-nav" v-if="isStaff">
							<li v-on:click="onNavbarToggle">
								<a href="javascript:void(0);" @click="toCreateOrder" class="text-center">
									<span class="title">新建订单</span>
								</a>
							</li>
							<li>
								<div class="divider"></div>
							</li>
							<li v-on:click="onNavbarToggle">
								<a href="javascript:void(0);" @click="toOrderList" class="text-center">
									<span class="title">订单列表</span>
								</a>
							</li>
						</ul>
						<ul class="nav navbar-nav" v-if="!isStaff">
							<li v-on:click="onNavbarToggle">
								<a href="javascript:void(0);" @click="toMyOrderList" class="text-center">
									<span class="title">订单列表</span>
								</a>
							</li>
						</ul>
					</div><!--/.nav-collapse -->
				</div>
			</nav>
		</div>
		<div class="clear-fix"></div>
		<div v-show="auth" class="content-container">
			<div class="container">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MessageBox } from 'mint-ui'

export default {
	name: 'app',
	components: {
	},
	computed: {
		...mapGetters({
			page: 'getPage',
			navbar: 'getNavbar',
			alert: 'getAlert',
			logoPath: 'getLogoPath'
		})
	},
	data: () => ({
		'auth': false,
		'isStaff': false,
		'menuBtn': '/static/img/menu_btn_black.png'
	}),
	methods: {
		toCreateOrder () {
			this.$store.dispatch('clearNewOrder', {})
			this.$router.replace({'name': 'OrderNew'})
		},
		toOrderList () {
			this.$router.replace({'name': 'ManageOrderList'})
		},
		toMyOrderList () {
			this.$store.dispatch('setOrder', {'order': {}})
			this.$router.replace({'name': 'MyOrderList'})
		},
		onScreenClick (event) {
			this.$store.dispatch('setNavbar', {'collapse': true})
		},
		onNavbarToggle (event) {
			this.$store.dispatch('setNavbar', {'collapse': !this.navbar.collapse})
		},
		fetchSession () {
			let url = '/api/session'
			this.$http.post(url).then(response => {
				this.loadingHide()
				console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					this.auth = true
					this.$store.dispatch('setQyh', {'qyh': {'qr': rs.data.qyhqr, 'wx': rs.data.inWx, 'mobile': rs.data.inMobile, 'pay_split_step': rs.data.pay_split_step}})
					this.isStaff = rs.data.role === 'staff'
					if (rs.data.alert) {
						MessageBox.alert(rs.data.alert)
					}
					this.$store.dispatch('setRole', rs.data.role)
					// let currentUrl = this.$ls.get('currentUrl_')
					// console.log('currentUrl: ', currentUrl)
					// if (currentUrl) {
					// 	currentUrl = JSON.parse(currentUrl)
					// 	if (currentUrl.name && currentUrl.name !== 'Home') {
					// 		this.$router.replace({name: currentUrl.name, params: currentUrl.params})
					// 		return
					// 	}
					// }
					if (rs.data.index === 'OrderPay' && rs.data.id) {
						window.location.href = '?#/pay/ways/' + rs.data.id
					} else if (rs.data.index === 'PaySplit' && rs.data.id) {
						window.location.href = '?#/pay/split/' + rs.data.id
					} else if (rs.data.index === 'TransList' && rs.data.id) {
						window.location.href = '#/trans/' + rs.data.id
					} else if (rs.data.index === 'OneKeyPayment' && rs.data.id) {
						window.location.href = '?#/onekey/payment/' + rs.data.id
					} else {
						if (rs.data.id) {
							this.$router.replace({name: rs.data.index, params: {id: rs.data.id}})
						} else {
							if (rs.data.index === 'MyOrderList') {
								window.location.href = '?#/my/orders'
							} else {
								this.$router.replace({name: rs.data.index})
							}
						}
					}
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		}
	},
	created: function () {
		if (window.location.host === 'fuwu.zhongyingtougu.com' || window.location.host === 'order.qtest.daohehui.com') {
			this.logoPath = '/static/img/logo2.png'
		} else if (window.location.host === 'commission.zhongyingtougu.com' || window.location.host === 'yongjin.daohehui.com') {
			this.logoPath = '/static/img/commission_logo.png'
		}
		this.fetchSession()
	},
	mounted: function () {
		this.loading('正在读取...')
	},
	beforeDestroy: function () {
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue